/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CloseRelativeAddressCreate } from './closeRelativeAddressCreate';
import { RelativeStatusEnum } from './relativeStatusEnum';
import { RelativeTypeEnum } from './relativeTypeEnum';

export interface PatchedCloseRelativeUpdate { 
    relativeType?: RelativeTypeEnum;
    status?: RelativeStatusEnum;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    birthDate?: string;
    dataBox?: string;
    bankAccountNumber?: string;
    bankCode?: string;
    bankName?: string;
    iban?: string;
    swift?: string;
    note?: string;
    isPrimary?: boolean;
    addresses?: Array<CloseRelativeAddressCreate>;
}